module.exports = __webpack_public_path__ + "static/media/create_location.a380d964.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/create_location.png
// module id = 781
// module chunks = 0